<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="600"
    :height="130"
    :title="popupConfig.title"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    >
    </DxToolbarItem>
    <DxToolbarItem
      #default
      location="after"
      locate-in-menu="auto"
      :v-if="popupConfig.formMode !== 'create'"
    >
    </DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form">
      <gc-form
        :key="popupConfig.formKey"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="model"
        :form-mode="popupConfig.formMode"
        :from-from="'gc-header-form-d-a'"
        :form-height="popupConfig.height - 20"
        :formContentReady="formContentReady"
        v-if="IsFormLoaded"
      />
    </div>
  </DxPopup>
</template>
<script>
import { mapGetters } from "vuex";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { SalesOrderPlanningService } from "../_services/api/sales/sales-order-planning";

export default {
  mixins: [DataGridMixin],
  data() {
    return {
      model: {
        Status: undefined,
      },
      IsFormLoaded: false,
      selectedRowsData: [],
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {
        return {
          class: "css-v2 gc-popup gc-popup-form gc-popup-work-order",
        };
      },
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    applicationFeatureCode: {
      type: String,
      default: "SalesOrder",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    setTimeout(() => {
      this.IsFormLoaded = true;
    }, 100);
  },
  methods: {
    /**
     * on popup model shown
     */
    onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.model.Status = undefined;
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler() {
      this.showLoading(true);
      let payload = {
        SalesOrderDetailRecordIdList:
          this.popupConfig.SalesOrderDetailRecordIdList,
        Value: this.model.Status,
        Attribute: this.popupConfig.Attribute,
      };

      SalesOrderPlanningService.savePTStatus(payload)
        .then(() => {
          this.showLoading(false);
          this.saveCallBack();
          this.$nextTick(() => {
            if (this.popupConfig.Attribute == "ProductionStatus")
              this.$notify(`Production status updated successfully`, "success");
            else
              this.$notify(`Transport status updated successfully`, "success");
          });
        })
        .catch((err) => {
          this.displayServerError(err, "Status Update Failed");
          this.showLoading(false);
        });
    },

    formContentReady() {
      setTimeout(() => {
        this.setFocusOnField("Status");
      }, 200);
    },

    /**
     * Set Focus on Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (
        this.$refs["gc-header-form"] &&
        this.popupConfig.formMode !== "review"
      ) {
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
          .getEditor(dataField)
          .focus();
      }
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        );
        if (confirm) {
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;
          }
          this.onPopupHide();
        }
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    getHeaderFormItems() {
      if (this.popupConfig.Attribute == "ProductionStatus")
        return [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "ProductionStatus",
                dataField: "Status",
                label: {
                  text: "New Status",
                },
                editorOptions: {
                  placeholder: "Select Production Status",
                  onOpened: (e) => {
                    let instance = e.component;
                    let items = [...instance.option().items];
                    if (items.length > 0) {
                      let index = items.findIndex((x) => x == "Planned");
                      if (index != -1) {
                        items.splice(index, 1);
                        e.component.beginUpdate();
                        e.component.option("items", items);
                        e.component.endUpdate();
                      }
                    }
                  },
                },
              },
            ],
          },
        ];
      else
        return [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "TransportStatus",
                dataField: "Status",
                label: {
                  text: "New Status",
                },
                editorOptions: {
                  placeholder: "Select Transport Status",
                },
              },
            ],
          },
        ];
    },
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          options: {
            text: "Update",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          options: {
            text: "Cancel",
            stylingMode: "outlined",
            type: "danger",
            onClick: this.onCancelPopupHandler,
          },
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-work-order {
  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .wo-data-details {
    background-color: white;
    margin: 0px 10px;

    .wo-so-toolbar {
      .dx-icon.dx-icon-plus::before {
        color: #03a9f4;
      }
    }
  }

  .wo-so-lines {
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 5px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-command-select.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
</style>
